import { _getAllProducts } from '@/services/data';
import { getActiveAuth } from '@/utils/getActiveAuth';
import { useRequest } from 'ahooks';
import { useState } from 'react';
export default () => {
  const [auth, setAuth] = useState({ trafficAuth: false, operateNoAuth: true, noAuth: true }); // 活动权限
  const [product, setProduct] = useState<Product.IInfo>(); //选中的产品信息
  const { data: productList = [] } = useRequest(_getAllProducts);

  const getAuth = async (gameCode: string) => {
    const auth = await getActiveAuth(gameCode);
    setAuth(auth);
    return auth;
  };

  return { auth, getAuth, product, setProduct, productList };
};
